import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2, RefreshCw } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 px-4 bg-gradient-to-b from-bg-card to-bg-primary relative overflow-hidden" data-id="element-52">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-cta-primary/5 blur-[100px]" data-id="element-53" />

      <div className="container max-w-4xl mx-auto relative z-10" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-55">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-cta-primary/20 border-4 border-cta-primary/40 mb-6" data-id="element-56">
            <ShieldCheck className="w-10 h-10 text-cta-primary" data-id="element-57" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-extrabold text-text-primary mb-4" data-id="element-58">
            Garantía de 7 Días
          </h2>
          <p className="text-xl text-cta-primary font-bold uppercase tracking-wider" data-id="element-59">
            100% Sin Riesgo
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-bg-card border-2 border-cta-primary/50 rounded-3xl p-8 md:p-12 shadow-[0_0_60px_rgba(34,197,94,0.15)]" data-id="element-60">
          <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-61">
            {[{
            icon: CheckCircle2,
            title: 'Compra Segura',
            desc: 'Prueba el método completo sin compromiso'
          }, {
            icon: RefreshCw,
            title: 'Reembolso Fácil',
            desc: 'Devolución en 7 días, sin preguntas'
          }, {
            icon: ShieldCheck,
            title: 'Cero Riesgo',
            desc: 'Tu inversión está 100% protegida'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3 + i * 0.1
          }} className="text-center" data-id="element-62">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-cta-primary/10 border border-cta-primary/30 mb-4" data-id="element-63">
                  <item.icon className="w-8 h-8 text-cta-primary" data-id="element-64" />
                </div>
                <h3 className="text-lg font-bold text-text-primary mb-2" data-id="element-65">
                  {item.title}
                </h3>
                <p className="text-sm text-text-secondary" data-id="element-66">{item.desc}</p>
              </motion.div>)}
          </div>

          <div className="bg-bg-primary/50 border border-border-color rounded-2xl p-6 md:p-8" data-id="element-67">
            <p className="text-lg md:text-xl text-text-primary leading-relaxed text-center" data-id="element-68">
              <span className="font-bold text-cta-primary" data-id="element-69">
                "Si lo compras, lo revisas y sentís que no es para ti, pedís
                reembolso dentro de 7 días y listo. Sin preguntas incómodas."
              </span>
            </p>{' '}
          </div>
        </motion.div>
      </div>
    </section>;
}